const CreateEditRole = () => {
  return <h1>Create Edit Role</h1>
}
export default CreateEditRole
